// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=js+dts"
// @generated from file booking_gateway/v1/vouchers.proto (package booking_gateway.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetActiveBenefitsRequest, GetActiveBenefitsResponse, GetVoucherByCodeRequest, GetVoucherByCodeResponse, RedeemBenefitRequest, RedeemBenefitResponse, RedeemVoucherRequest, RedeemVoucherResponse, ReleaseBenefitRequest, ReleaseBenefitResponse, ReleaseVoucherRequest, ReleaseVoucherResponse } from "./vouchers_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service booking_gateway.v1.Vouchers
 */
export const Vouchers = {
  typeName: "booking_gateway.v1.Vouchers",
  methods: {
    /**
     * @generated from rpc booking_gateway.v1.Vouchers.GetVoucherByCode
     */
    getVoucherByCode: {
      name: "GetVoucherByCode",
      I: GetVoucherByCodeRequest,
      O: GetVoucherByCodeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc booking_gateway.v1.Vouchers.RedeemVoucher
     */
    redeemVoucher: {
      name: "RedeemVoucher",
      I: RedeemVoucherRequest,
      O: RedeemVoucherResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc booking_gateway.v1.Vouchers.ReleaseVoucher
     */
    releaseVoucher: {
      name: "ReleaseVoucher",
      I: ReleaseVoucherRequest,
      O: ReleaseVoucherResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc booking_gateway.v1.Vouchers.GetActiveBenefits
     */
    getActiveBenefits: {
      name: "GetActiveBenefits",
      I: GetActiveBenefitsRequest,
      O: GetActiveBenefitsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc booking_gateway.v1.Vouchers.RedeemBenefit
     */
    redeemBenefit: {
      name: "RedeemBenefit",
      I: RedeemBenefitRequest,
      O: RedeemBenefitResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc booking_gateway.v1.Vouchers.ReleaseBenefit
     */
    releaseBenefit: {
      name: "ReleaseBenefit",
      I: ReleaseBenefitRequest,
      O: ReleaseBenefitResponse,
      kind: MethodKind.Unary,
    },
  }
};

